import { render, staticRenderFns } from "./VibrationDiagramBox.vue?vue&type=template&id=2036241f&scoped=true&"
import script from "./VibrationDiagramBox.vue?vue&type=script&lang=ts&"
export * from "./VibrationDiagramBox.vue?vue&type=script&lang=ts&"
import style0 from "./VibrationDiagramBox.vue?vue&type=style&index=0&id=2036241f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036241f",
  null
  
)

export default component.exports